import { z } from 'zod';
import type { SizeGuideToken } from '@sleed/bizcommerce-api';

/**
 * Size guide edit form. Mirrors `SizeGuideToken` and the legacy admin popup
 * (Core/client/admin/src/pages/Catalog/SizeGuides/index.js): tl (title) required ≤100, cd optional ≤50,
 * iv boolean, bd rich-text body. The default-language title/body are saved at the top level via the
 * Accept-Language=el pin (parity with the other catalog editors).
 */
export const sizeGuideSchema = z.object({
	id: z.number().optional(),
	tl: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	cd: z.string().trim().max(50, 'validation.tooLong').nullable(),
	iv: z.boolean(),
	bd: z.string().nullable(),
	si: z.number().int()
});

export type SizeGuideFormValues = z.infer<typeof sizeGuideSchema>;

export const EMPTY_SIZE_GUIDE: SizeGuideFormValues = {
	tl: '',
	cd: '',
	iv: true,
	bd: null,
	si: 0
};

export function tokenToForm(token: SizeGuideToken): SizeGuideFormValues {
	return {
		id: token.id,
		tl: token.tl ?? '',
		cd: token.cd ?? '',
		iv: token.iv ?? false,
		bd: token.bd ?? null,
		si: token.si ?? 0
	};
}

export function formToToken(form: SizeGuideFormValues): SizeGuideToken {
	return {
		id: form.id,
		tl: form.tl.trim(),
		cd: form.cd?.trim() || null,
		iv: form.iv,
		bd: form.bd,
		si: form.si
	};
}
